import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/itemcard.module.scss'
import { formatMoney } from 'services/util'

export default function FixedItemPurchaseButton({amount, setShowFixedItemModal, setPurchaseQuantity, setPurchaseItem, item}) {

  const { LimitPerPerson, MyAmountPurchased, TotalItemsAvailable, TotalItemsPurchased } = item

  //if there are no items available
  if (TotalItemsAvailable === TotalItemsPurchased) {
    return (
      <button disabled className={`${themeCss['button']} ${themeCss['FilledYellow']} ${css['place-bid-button']}`}>
        Item is Sold Out
    </button>
    )
  }

  //if the user has reached the limit per person
  if (typeof LimitPerPerson === 'number' && MyAmountPurchased >= LimitPerPerson)  {
    return (
      <button disabled className={`${themeCss['button']} ${themeCss['FilledYellow']} ${css['place-bid-button']}`}>
        Quantity Limit Reached
    </button>
    )
  }

  // all other cases, user should be able to purchase
  return (
    <button disabled={isNaN(amount)} className={`${themeCss['button']} ${themeCss['FilledYellow']} ${css['place-bid-button']}`}
      onClick={() => {
          setShowFixedItemModal(true)
          setPurchaseQuantity(amount)
          setPurchaseItem(item)
        }}>
        Purchase for ${isNaN(amount) ? formatMoney(item.PurchasePrice) : formatMoney(amount * item.PurchasePrice)}
    </button>
  )
}